import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getLocalTranslate } from 'src/app/helpers/global-functions';
import { Book } from 'src/app/models/book.model';
import { Link } from 'src/app/models/link.model';
import { WordRefModel } from 'src/app/models/word-ref.model';
import { Word } from 'src/app/models/word.model';
import { CourseService } from 'src/app/services/course.service';
import { SharedService } from 'src/app/services/shared.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-dictionary',
  templateUrl: './dictionary.component.html',
  styleUrls: ['./dictionary.component.css']
})
export class DictionaryComponent implements OnInit {

  home: string = 'Home'
  dictionary: string = 'Phrasal Verbs'
  welcomeTo: string = 'Welcome to Phrasal Verbs Dictionary Online'
  welcomeToText: string = 'Phrasal verb dictionary online is a dictionary...'
  wordOf: string = '	Word of the day';
  wordOfText: string = 'Random words from the dictionry pop ups here every day';
  findOutMore: string = 'Find out more about our books';
  buyThisBook: string = 'Buy this book';
  searchWord:string = '	Search phrasal verbs';

  links: Link[] = []
  books: Book[] = []

  shimmerLinks: HTMLElement[] = [];

  searchWordsResult: WordRefModel[] = [];
  showShimmerWord: boolean = false;

  word: Word;


  constructor(private service: SharedService, private toastr: ToastrService, private titleService:Title) {

  }

  ngOnInit(): void {
    this.needTranslate();
    this.getLinks();
    this.getBooks();

    const id = '6BxtZVaxDzhJWKDgynkq';
    this.service.getBanner(id).then(result=>{
      const imageUrl = result.image.fileUrl;
      document.getElementById('bg-cover').style.backgroundImage = 'url(' + imageUrl + ')';
    })


  }

  needTranslate() {
    this.home = getLocalTranslate('home', this.home)
    this.dictionary = getLocalTranslate('dictionary', this.dictionary)
    this.welcomeTo = getLocalTranslate('welcome-to-phrasal-verbs-dictionary', this.welcomeTo);
    this.welcomeToText = getLocalTranslate('welcome-to-phrasal-verbs-dictionary-text', this.welcomeToText);
    this.wordOf = getLocalTranslate('word-of-the-day', this.wordOf);
    this.wordOfText = getLocalTranslate('word-of-the-day-text', this.wordOfText);
    this.findOutMore = getLocalTranslate('find-out-more-about-our-books', this.findOutMore);
    this.buyThisBook = getLocalTranslate('buy-this-book', this.buyThisBook);
    this.searchWord = getLocalTranslate('search-phrasal-verbs',this.searchWord);
    this.titleService.setTitle(`${getLocalTranslate('dictionary', this.dictionary)} | CamEdu`);
  }

  getLinks() {
    this.service.getLinks().then(links => {
      this.links = links;
      this.hideShimmerLinks();
    })
  }

  getBooks() {
    this.service.getBooks().then(books => {
      this.books = books;
      this.hideShimmerBooks();
    })
  }

  private hideShimmerLinks() {
    const shimmers = document.querySelectorAll('.shimmer-link-items');
    shimmers.forEach(element => {
      element.classList.add('hide');
    });
  }

  private hideShimmerBooks() {
    const shimmers = document.querySelectorAll('.shimmer-book-items');
    shimmers.forEach(element => {
      element.classList.add('hide');
    });
  }

  onSearchWords(event) {
    const text = event.toLowerCase();
    console.log(text);
    this.service.searchWords(text).then(result => {
      this.searchWordsResult = result;
    })
  }

  onSelectWord(event) {
    this.showShimmerWord = true;
    this.service.getWord(event).then(result => {
      console.log(result);
      this.word = result;
      this.showShimmerWord = false;
    }).catch(_ => {
      this.showShimmerWord = false;
      this.toastr.error("Oops, Something went wrong!");
    })

  }


}
